import { render, staticRenderFns } from "./currentstock.vue?vue&type=template&id=631909b6"
import script from "./currentstock.vue?vue&type=script&lang=js"
export * from "./currentstock.vue?vue&type=script&lang=js"
import style0 from "./currentstock.vue?vue&type=style&index=0&id=631909b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports